import axios from 'services/axios';
import { useFeatureFlagStore } from 'tools/feature-flags/feature-flags.zustand';
import { LDFeatureFlagEnum } from 'tools/feature-flags/launchdarkly-flags';

const BASE_API_URL = import.meta.env.VITE_APP_API_URL;

export const postProagricaUser = async (user_id: string, email: string) => {
  const enableV3Auth = useFeatureFlagStore
    .getState()
    .getLaunchDarklyFlag(LDFeatureFlagEnum.ENABLE_V3_AUTH);
  const endpoint = enableV3Auth ? '/auth-service/v3/authaccounts' : '/valet/v2/auth-account';

  try {
    const response = await axios.request({
      method: 'POST',
      url: `${BASE_API_URL}${endpoint}`,
      data: {
        user_id,
        partner: 'proagrica',
        settings: {
          email,
        },
        auth_config: {
          email: 'rpoling+telematics4@skywardapps.com',
        },
      },
    });
    return response;
  } catch (err: any) {
    console.error(err);
    if (!err.response) {
      return err;
    }
    const message = err.response?.data?.errors[0]?.message;
    if (!message.length) {
      return err;
    }
    // V3 doesn't need retry logic
    if (!enableV3Auth && message.indexOf('already exists') > -1) {
      return await patchProagricaUser(user_id);
    }
    return err;
  }
};

export const patchProagricaUser = async (user_id: string) => {
  try {
    const enableV3Auth = useFeatureFlagStore
      .getState()
      .getLaunchDarklyFlag(LDFeatureFlagEnum.ENABLE_V3_AUTH);
    const endpoint = enableV3Auth ? '/auth-service/v3/authaccounts' : '/valet/v2/auth-account';

    const integrationAccountBody = {
      auth_config: {
        email: 'rpoling+telematics4@skywardapps.com',
      },
    };
    const patchResponse = await axios.request({
      method: 'PATCH',
      url: `${BASE_API_URL}${endpoint}`,
      params: {
        user_id,
        partner: 'proagrica',
      },
      data: integrationAccountBody,
    });
    return patchResponse.data;
  } catch (err: any) {
    console.error(err);
    return err;
  }
};

export const getProagricaOrganizations = async (user_id: string) => {
  try {
    const response: any = await axios.request({
      method: 'GET',
      url: `${BASE_API_URL}/valet/v1/proagrica_orgs`,
      params: {
        user_id,
      },
    });
    const orgs = response.data.organizations.map((org: any) => {
      org.name = org.Name;
      org.id = org.ID;
      delete org.Name;
      delete org.ID;
      return org;
    });
    return orgs;
  } catch (err: any) {
    console.error('GET Proagrica Organizations:', err);
    return err;
  }
};
